// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  me: {},
  // meLoaded: false,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
